<template>
  <b-form-group
    label="Safra"
    :state="stateSafra"
    :invalid-feedback="mensagemErro"
  >
    <multiselect
      label="name"
      track-by="name"
      :loading="loading"
      :options="options"
      :class="isInvalid"
      v-model="valorSafra"
      placeholder="Selecione uma safra"
    />
  </b-form-group>
</template>

<script>
import Multiselect from "vue-multiselect";
import {SafraService} from "../../../../../services/astec/safras";

export default {
  name: "SelectSafra",
  components: {
    Multiselect
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    state: {
      type: Boolean,
      default: null
    },
  },
  data() {
    return {
      options: [],
      loading: false,
      valorSafra: this.value,
      mensagemErro: "O campo safra é obrigatorio."
    };
  },
  watch: {
    value(newVal) {
      this.valorSafra = newVal;
    },
    valorSafra(newVal) {
      this.$emit("input", newVal);
    },
  },
  computed: {
    isInvalid: function () {
      return {'is-invalid': !this.stateSafra};
    },
    stateSafra() {
      if (this.state !== null) return this.state;
      return !!this.valorSafra;
    }
  },
  async mounted() {
    await this.carregarSafras();
  },
  methods: {
    async carregarSafras() {
      this.loading = true;
      try {
        this.options = await SafraService.buscarLkpSafra();
      } catch (err) {
        console.error("Erro ao carregar safras:", err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
